import $ from "jquery";

export const PlainPage = () => {
    const isPlainTemplate = $("#plain-page-template").length > 0;

    if (!isPlainTemplate) return;

    const elm = $(".transitionPage");

    setTimeout(() => {
        elm.removeClass("is-active");
    }, 1000);
};
